import Cookie from 'js-cookie';
import { STORAGE } from 'shared/enums/SitePreferences';
import { GLOBAL_PRICING_ID, GLOBAL_PRICING_REGIONS } from 'shared/enums/GlobalPricing';
import { updateRegionPreferences } from 'account/services/regionPreferences';
import { bugsnag } from 'shared/utils/services/bugsnag';

export const setSitePreferences = async ({ currency, country, isAuthenticated, context }) => {
  Cookie.set(STORAGE.CURRENCY, currency);
  Cookie.set(STORAGE.COUNTRY, country);

  // Update global_pricing_id in cookies
  const globalPricingRegions = Cookie.get(GLOBAL_PRICING_REGIONS);
  const globalPricingRegionsMap = globalPricingRegions && JSON.parse(globalPricingRegions);
  const globalPricingId = globalPricingRegionsMap?.[country] || null;
  Cookie.set(GLOBAL_PRICING_ID, JSON.stringify(globalPricingId));

  if (isAuthenticated) {
    try {
      await updateRegionPreferences(country);
    } catch (error) {
      bugsnag(error, { context });
    }
  }
};
